import { AcceptedVideoTypes } from '@/utils/getMimeTypeFromFileExtension';

const getExtensionFromFileName = (filename: string): AcceptedVideoTypes => {
  return (filename.split('.').pop() as AcceptedVideoTypes) || 'video/webm';
};

export default getExtensionFromFileName;
